import React, { useState, useEffect, useRef } from 'react';
import { useTheme  } from '../context/ThemeContext';
import { UserAuth } from '../context/AuthContext';
import Header from './header';
import think from '../images/thinking.png';
import { 
  BookMarked, 
  Clock, 
  Search, 
  ChevronDown, 
  Trash2,
  ExternalLink,
  Filter,
  Type,
  RefreshCw,
} from 'lucide-react';
import DownloadDocxButton from './share/DW';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import ShareToWhatsApp from './share/ShareToWhatsApp';
import MarkupTextCopier from './pop/htmltomkd';
import ActionButtons from './pop/action';
import '../components/Chat/savedChats.css'

const SavedQuestions = () => {
  const { token } = UserAuth();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const { isDarkMode, themeClass, toggleTheme } = useTheme();
  const [sortBy, setSortBy] = useState('newest');
   const [fontSize, setFontSize] = useState(18);
   const [htmltext, setHtmlText] = useState('');
   const questionRefs = useRef({});
   const findScrollableParent = (element) => {
    if (!element) return document.documentElement;
    
    const style = window.getComputedStyle(element);
    const hasScroll = style.overflow === 'auto' || 
                    style.overflow === 'scroll' ||
                    style.overflowY === 'auto' ||
                    style.overflowY === 'scroll';
    
    if (hasScroll && element.scrollHeight > element.clientHeight) {
      return element;
    }
    
    return findScrollableParent(element.parentElement);
  };
   const handleQuestionDeleted = (deletedId) => {
    setQuestions(prevQuestions => prevQuestions.filter(q => q.id !== deletedId));
  };
    // State for dynamic font family (default is your --body-font, e.g., Poppins)
    const [fontFamily, setFontFamily] = useState('var(--body-font)');
    const [animationType, setAnimationType] = useState(0);

    const pickRandomAnimation = () => {
      setAnimationType(Math.floor(Math.random() * 3));
    };

    const animations = [
      () => <div className="loader"></div>,
      () => (
        <div aria-label="Orange and tan hamster running in a metal wheel" role="img" className="wheel-and-hamster">
          <div className="wheel"></div>
          <div className="hamster">
            <div className="hamster__body">
              <div className="hamster__head">
                <div className="hamster__ear"></div>
                <div className="hamster__eye"></div>
                <div className="hamster__nose"></div>
              </div>
              <div className="hamster__limb hamster__limb--fr"></div>
              <div className="hamster__limb hamster__limb--fl"></div>
              <div className="hamster__limb hamster__limb--br"></div>
              <div className="hamster__limb hamster__limb--bl"></div>
              <div className="hamster__tail"></div>
            </div>
          </div>
          <div className="spoke"></div>
        </div>
      ),
      () => <div className="loader2"></div>
    ];

    const renderAnimation = () => {
      switch(animationType) {
        case 0:
          return <div className="loader"></div>;
        case 1:
          return (
            <div aria-label="Orange and tan hamster running in a metal wheel" role="img" className="wheel-and-hamster">
              <div className="wheel"></div>
              <div className="hamster">
                <div className="hamster__body">
                  <div className="hamster__head">
                    <div className="hamster__ear"></div>
                    <div className="hamster__eye"></div>
                    <div className="hamster__nose"></div>
                  </div>
                  <div className="hamster__limb hamster__limb--fr"></div>
                  <div className="hamster__limb hamster__limb--fl"></div>
                  <div className="hamster__limb hamster__limb--br"></div>
                  <div className="hamster__limb hamster__limb--bl"></div>
                  <div className="hamster__tail"></div>
                </div>
              </div>
              <div className="spoke"></div>
            </div>
          );
        case 2:
          return <div className="loader2"></div>;
        default:
          return <div className="loader"></div>;
      }
    };
    
    function markdownToWhatsApp(text) {
      let whatsappFormattedText = text;
      whatsappFormattedText = whatsappFormattedText.replace(/(\*\*|__)(.*?)\1/g, '*$2*');
      whatsappFormattedText = whatsappFormattedText.replace(/(\*|_)(.*?)\1/g, '_$2_');
      whatsappFormattedText = whatsappFormattedText.replace(/~~(.*?)~~/g, '~$1~');
      whatsappFormattedText = whatsappFormattedText.replace(/^(\s*)#+([^\n]*)/gm, '$1*$2*');
      whatsappFormattedText = whatsappFormattedText.replace(/(\[)(.*?)(\])/g, '_$2_');
      whatsappFormattedText = whatsappFormattedText.replace(/\* /g, '*');
      whatsappFormattedText = whatsappFormattedText.replace(/ \*\n/g, '*\n');
      whatsappFormattedText = whatsappFormattedText.replace(/_ /g, '_');
      whatsappFormattedText = whatsappFormattedText.replace(/ _\n/g, '_\n');
      return whatsappFormattedText;
    }

  useEffect(() => {
    pickRandomAnimation();
    fetchQuestions();
  }, []);
  useEffect(() => {
    if (expandedId && questionRefs.current[expandedId]) {
      setTimeout(() => {
        const element = questionRefs.current[expandedId];
        const scrollableParent = findScrollableParent(element);
        const elementRect = element.getBoundingClientRect();
        const parentRect = scrollableParent.getBoundingClientRect();
        
        // Calculate the scroll position to center the element
        const scrollTop = elementRect.top - parentRect.top - (parentRect.height - elementRect.height) / 4;
        
        scrollableParent.scrollTo({
          top: scrollableParent.scrollTop + scrollTop,
          behavior: 'smooth'
        });
      }, 100);
    }
  }, [expandedId]);

  const fetchQuestions = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL_GUARDAR_PREGUNTA}/api/obtener_todas`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      const data = await response.json();
      if (data.success) {
        setQuestions(data.data);
      }
      else {
        // Alert for error from API response
        alert(data.error || 'Error al obtener las preguntas');
      }

    } catch (error) {
      console.error('Error fetching saved questions:', error);
      
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const filteredQuestions = questions
    .filter(q => 
      q.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      q.content?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (sortBy === 'newest') {
        return new Date(b.creation) - new Date(a.creation);
      } else {
        return new Date(a.creation) - new Date(b.creation);
      }
    });

  return (
    <div className="content-section savingqesution">
      <div className={`header-chat still plan ${themeClass}`}>
        <Header 
          
        />
        |
        {/* Toggle de Tema */}
          <div className="theme-toggle small-toggle">
            <span className="colorIconToggle">☼</span>
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={isDarkMode}
                onChange={toggleTheme}
                className="toggle-input"
              />
              <span className={`toggle-slider ${themeClass}`}>
                <span className={`toggle-knob ${themeClass}`} />
              </span>
            </label>
            <span className="colorIconToggle">☽</span>
          </div>
      </div>
      {/* Header Section */}
      <div className="content-wrapper-header2">
          <h2 className={`titulopregguard ${themeClass}`}>
            Preguntas Guardadas
          </h2>
      </div>

      {/* Search and Filter Section */}
      <div className={`boxofinput ${themeClass}`}>
        <div className={`inputsearchsaved ${themeClass}`}>
          <Search size={20} style={{ color: 'var(--secondary)', marginRight: '10px' }} />
          <input
            type="text"
            placeholder="Buscar en preguntas guardadas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={`inputpregguard ${themeClass}`}
          />
        </div>
        
        <button
          onClick={() => setFilterOpen(!filterOpen)}
          className={`filterSaved ${themeClass}`}
        >
          <Filter size={20}/>
          Ordenar
          <ChevronDown 
            size={16} 
            style={{ 
              transform: filterOpen ? 'rotate(180deg)' : 'none',
              transition: 'transform 0.3s ease'
            }} 
          />
        </button>
      </div>

      {/* Filter Dropdown */}
      {filterOpen && (
        <div className={`dropdownfilter ${themeClass}`}>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={() => setSortBy('newest')}
              style={{
                background: sortBy === 'newest' ? 'var(--Blue)' : 'rgba(22, 35, 112, 0.1)',
                color: sortBy === 'newest' ? (isDarkMode ? '#fff' : 'var(--sWhite')  : 'var(--secondary)',
                border: 'none',
                borderRadius: '6px',
                padding: '8px 15px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontSize: ' var(--H6)',
                fontFamily: 'var(--H6-family)',
                fontWeight: 'var(--H6-weight)'
              }}
            >
              Más recientes
            </button>
            <button
              onClick={() => setSortBy('oldest')}
              style={{
                background: sortBy === 'oldest'  ? 'var(--Yellow)' : 'rgba(171, 174, 28, 0.1)',
                color: sortBy === 'newest' ? (isDarkMode ? 'var(--primary)' : 'var(--tertiary')  : 'var(--primary)',
                border: 'none',
                borderRadius: '6px',
                padding: '8px 15px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                fontSize: ' var(--H6)',
                fontFamily: 'var(--H6-family)',
                fontWeight: 'var(--H6-weight)'
              }}
            >
              Más antiguos
            </button>
          </div>
        </div>
      )}

      {/* Questions List */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {/* Filter Dropdown */}
        {filterOpen && (
          <div className={`dropdownfilter ${themeClass}`}>
            {/* ... código del dropdown ... */}
          </div>
        )}

        {/* LOADER */}
        {loading && (
          <div className="loader-container">
            {renderAnimation()}
          </div>
        )}

        {/* Questions List */}
        {!loading && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {filteredQuestions.map((question) => (
              <div
                key={question.id}
                className={`borderquestion ${themeClass}`} 
                onClick={() => setExpandedId(expandedId === question.id ? null : question.id)}
              >
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'flex-start',
                  marginBottom: expandedId === question.id ? '15px' : '0'
                }}>
                  <div>
                    <h3 ref={el => questionRefs.current[question.id] = el}
                    className={`titleOfSaved ${themeClass}`} >
                      {question.title || 'Sin título'}
                    </h3>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '8px',
                      color: 'var(--secondary)',
                      fontSize: '0.9rem'
                    }}>
                      <Clock size={16} />
                      {formatDate(question.creation)}
                    </div>
                  </div>
                  <ChevronDown 
                    size={20} 
                    style={{ 
                      color: 'var(--sRed)',
                      transform: expandedId === question.id ? 'rotate(180deg)' : 'none',
                      transition: 'transform 0.3s ease'
                    }} 
                  />
                </div>

                {expandedId === question.id && (
                  <div onClick={(e) => e.stopPropagation()}>
                    <div style={{ 
                      marginBottom: '1.5em',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      padding: '5px',
                      borderRadius: '8px',
                      width:'20%'
                    }}>
                      <label 
                        htmlFor="fontSizeSlider"
                        style={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          gap: '8px',
                          color: 'var(--secondary)',
                          fontWeight: '500'
                        }}
                      >
                        <Type size={18} />
                        Tamaño
                      </label>
                      <input
                        id="fontSizeSlider"
                        type="range"
                        min="14"
                        max="32"
                        value={fontSize}
                        onChange={(e) => setFontSize(e.target.value)}
                        style={{ 
                          flex: 1,
                          accentColor: 'var(--Yellow)',
                          height: '2px'
                        }}
                      />
                      <button
                        onClick={() => setFontSize(18)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: 'var(--theme-bg-color)',
                          border: '1px solid rgba(240, 219, 59, 0.3)',
                          borderRadius: '6px',
                          padding: '6px',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          color: 'var(--Yellow)'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = 'rotate(180deg)';
                          e.currentTarget.style.backgroundColor = 'rgba(59, 240, 131, 0.1)';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = 'rotate(0deg)';
                          e.currentTarget.style.backgroundColor = 'var(--theme-bg-color)';
                        }}
                      >
                        <RefreshCw size={16} />
                      </button>
                    </div>
                    
                    {/* Font Family Select */}
                    <div style={{ 
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      paddingLeft: '12px',
                      borderRadius: '8px',
                      width: '20%'
                    }}>
                      <label 
                        htmlFor="fontFamilySelect"
                        style={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          gap: '8px',
                          color: 'var(--secondary)',
                          fontWeight: '500'
                        }}
                      >
                        <Type size={18} />
                        Fuente
                      </label>
                      <div style={{ position: 'relative', flex: 1 }}>
                        <select
                          className={`selectedSavings ${themeClass}`} 
                          id="fontFamilySelect"
                          value={fontFamily}
                          onChange={(e) => setFontFamily(e.target.value)}
                        >
                          <option className={`selectorSaved ${themeClass}`} value="var(--body-font)">Normal</option>
                          <option value="OpenDyslexic">Para Dislexicos</option>
                          <option value="Rumiko Clear">Rumiko</option>
                        </select>
                        <div style={{
                          position: 'absolute',
                          right: '12px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          pointerEvents: 'none'
                        }}>
                          <ChevronDown size={16} color="#fb584542" />
                        </div>
                      </div>
                    </div>
                    
                    <ActionButtons question={question} markdownToWhatsApp={markdownToWhatsApp} onQuestionDeleted={handleQuestionDeleted} />
                    
                    <div className='parrafo parrafoMob'
                      style={{
                        fontSize: `${fontSize}px`,
                        fontFamily: fontFamily,
                      }}>
                      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked.parse(question.content || '')) }}></div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Empty State */}
      {!loading && filteredQuestions.length === 0 && (
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          color: 'var(--inactive-color)'
        }}>
          <img src={think} alt='withoutsaving' className='thinks'/>
          <p className={`nohaypreg ${themeClass}`}>Parece que aún no tienes preguntas guardadas</p>
        </div>
      )}
    </div>
  );
};

export default SavedQuestions;